import { render, staticRenderFns } from "./InstructionsButton.vue?vue&type=template&id=057fad87&"
import script from "./InstructionsButton.vue?vue&type=script&lang=ts&"
export * from "./InstructionsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports